import axios from "axios";

export const fetchData = async (subURL: string): Promise<any> => {
  const URL =
    process.env.REACT_APP_VMV_URL ??
    "https://api.korian-solutions.fr/vmv/v1/stats/";

  const { data } = await axios.get(`${URL}${subURL}`);
  return data;
};

export const fetchDropDownData = async (subURL: string): Promise<any> => {
  const URL =
    process.env.REACT_APP_VMV_URL_DROP_DOWN ??
    "https://ase-vmv-back.azurewebsites.net/";

  const { data } = await axios.get(`${URL}${subURL}`);
  return data;
};
